import { z } from 'zod'

export const ImportPlayValueSchema = z.object({
  file: z
    .instanceof(File)
    .nullable()
    .refine((file) => file !== null, {
      message: 'File is required',
      path: ['file'],
    }),
  pass: z
    .object({
      name: z.string(),
      uuid: z.string().optional(),
    })
    .nullable()
    .refine((sub) => sub !== null, {
      message: 'Pass is required',
      path: ['pass'],
    }),
  timezone: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable()
    .refine((tz) => tz !== null, {
      message: 'Timezone is required',
      path: ['timezone'],
    }),
})
